// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18 18.5V5.5M5.58561 13.2276L4.0039 18.5H4L5.58561 13.2276ZM5.58561 13.2276L7.90386 5.5H9.20386L11.5651 13.371M11.5651 13.371L13.1038 18.5H13.0999L11.5651 13.371ZM5.95381 13.371H11.1538","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai',
    ref,
    icon: element,
  },
));

AiIcon.displayName = 'AiIcon';

export default AiIcon;
